import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { Documentos } from '../../../../models/documentos.model';
import { Router } from '@angular/router';


@Component({
    selector: 'termo-servicos',
    templateUrl: './termoServicos.html',
    styleUrls: []
})
export class TermoServicosComponent implements OnInit {
    ident = "TermoServicos";
    item:any = {
        texto:"",
        titulo:"",
        ident:this.ident};
    init = {
        selector: 'textarea',
        height: 300,
        plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table contextmenu paste imagetools wordcount"
          ],
          toolbar: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
        // imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        content_css: [
          '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
          '//www.tinymce.com/css/codepen.min.css'
        ],
        language_url:"./assets/langs/pt_BR.js",
        browser_spellcheck: true,
        contextmenu: false
      
    };

    constructor( private db: AngularFirestore,
     private router:Router) { }

    ngOnInit() {
      let obj =  new Documentos(this.db)  
      obj.getDocumento(this.ident,r=>{
          this.item = r[0];
      })
    
    }

    doClick(){
        this.item.ident = this.ident;
        let obj =  new Documentos(this.db);
        obj.post(this.item,r=>{
            this.item = r;
            this.router.navigate(["/"]);
        })
         
    }

}
